import React from 'react';
import map from 'lodash/map';
import PaddingBox from '../../components/PaddingBox';
import { isMobile } from '../../utils/device';
import { COPYRIGHT_UNICODE } from '../../utils/const';
import classes from './styles/index.module.scss';
import { TooltipBtn } from '../../components/TooltipBtn';
import { Justify } from '../../components/Icons/Justify';

const UnAuthorizedFooter = (props) => {
	const { footerNavigation, customerName } = props;

	const getLoginFooterNavigationTooltip = () => {
		return (
			<TooltipBtn
				tooltip={
					<ul className={classes.loginPageFooterTooltipNavigation}>
						{map(footerNavigation, (navItem) => (
							<li
								className={classes.loginPageFooterTooltipNavigationItem}
								key={navItem.url}
							>
								<a href={navItem.url}>{navItem.title}</a>
							</li>
						))}
					</ul>
				}
				icon={<Justify />}
				styledButton
				hasTooltipIcon={false}
				rounded
				className={classes.loginPageFooterNavigationBurger}
				size='small'
			/>
		);
	};

	const getLoginFooterNavigationList = () => {
		return (
			<ul className={classes.loginPageFooterNavigation}>
				{map(footerNavigation, (navItem) => (
					<li
						className={classes.loginPageFooterNavigationItem}
						key={navItem.url}
					>
						<a href={navItem.url}>{navItem.title}</a>
					</li>
				))}
			</ul>
		);
	};

	const getAuthenticationFooter = () => {
		return isMobile ? getLoginFooterNavigationTooltip() : getLoginFooterNavigationList();
	};

	return (
		<div className={classes.footerAuthentication}>
			<PaddingBox
				className={classes.footerAuthenticatonContainer}
				hrLarge={!isMobile}
				hrSmall={isMobile}
			>
				<div className={classes.footerLeft}>
					<span>{`${COPYRIGHT_UNICODE} ${new Date().getFullYear()} ${customerName}`}</span>
				</div>
				<div className={classes.footerRight}>{getAuthenticationFooter()}</div>
			</PaddingBox>
		</div>
	);
};

UnAuthorizedFooter.propTypes = {};

export { UnAuthorizedFooter };
